import React from "react";
import { Bar, Pie } from "react-chartjs-2";
import moment from "moment";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
export const DebtDetailsChart = ({
  module,
  amortizationData,
  amortizationDataAll,
  loading,
}) => {
  // Assuming amortizationArray comes from your API response
  const amortizationArray = amortizationData ? amortizationData : [];

  const currentMonth = moment().startOf("month");
  const filteredAmortizationArray = amortizationArray.filter((item) =>
    moment(item.date, "MM-DD-YYYY").isSameOrAfter(currentMonth, "month")
  );
  // Map labels for months
  const labels =
    filteredAmortizationArray &&
    filteredAmortizationArray.map((item) =>
      moment(item.date, "MM-DD-YYYY").format("MMM,YYYY")
    );

  // Map monthly payments & balances
  const monthlyPayments =
    filteredAmortizationArray &&
    filteredAmortizationArray.map((item) => parseFloat(item.monthlyPayment));
  const remainingBalances =
    filteredAmortizationArray &&
    filteredAmortizationArray.map((item) => parseFloat(item.balance));

  // Sum cumulative values
  const lastEntry =
    amortizationArray && amortizationArray.length > 0
      ? amortizationArray[amortizationArray.length - 1]
      : null;

  // Use cumulative values from the last entry
  const totalCumulativeInterest = lastEntry
    ? parseFloat(lastEntry.cumulativeInterest)
    : 0;

  const totalCumulativePrincipal = lastEntry
    ? parseFloat(lastEntry.cumulativePrincipal)
    : 0;
  const dataBar = {
    labels: labels || [],
    datasets: [
      {
        label: "Monthly Payment",
        backgroundColor: "#09A84D", // green
        data: monthlyPayments || [],
      },
      {
        label: "Total Balance",
        backgroundColor: "#2A3DA3", // blue
        data: remainingBalances || [],
      },
    ],
  };

  console.log("datatata", dataBar, amortizationData, amortizationDataAll);

  const dataDonut = {
    labels: ["Cumulative Interest", "Cumulative Principal"],
    datasets: [
      {
        data: [totalCumulativeInterest, totalCumulativePrincipal],
        backgroundColor: ["#2A3DA3", "#09A84D"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "top",
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      callbacks: {
        label: function (tooltipItem, chartData) {
          // Get dataset label
          const datasetLabel =
            chartData.datasets[tooltipItem.datasetIndex].label || "";
          // Get value
          const value = tooltipItem.yLabel;
          // Format to 2 decimals
          const formattedValue = parseFloat(value)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return `${datasetLabel}: $${formattedValue}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          // stacked: true,
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          // ticks: {
          //   beginAtZero: true,
          // },
        },
      ],
      yAxes: [
        {
          // stacked: true,
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
            // beginAtZero: true,
          },
        },
      ],
    },
  };
  return (
    <div style={{ position: "relative" }}>
      {module && module === "Credit" ? (
        <Pie
          data={dataDonut}
          options={{
            legend: {
              display: true,
              position: "right",
              labels: {
                font: {
                  size: 14,
                },
                usePointStyle: true,
              },
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  const datasetLabel = dataset.label || "";
                  const value = dataset.data[tooltipItem.index] || 0;
                  const formattedValue = parseFloat(value)
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  return `${datasetLabel}: $${formattedValue}`;
                },
              },
            },
            plugins: {},
          }}
        />
      ) : (
        <Bar data={dataBar} options={options} height={280} />
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
